import * as angular from 'angular';

export class HasErrorElemCtrl implements ng.IController {
    private ngFormCtrl: ng.IFormController;
    private ngModelCtrl: angular.INgModelController;
    private pkpHasErrorAttr: string;
    private elem: HTMLElement;
    private doCheckListenerRegistered: boolean = false;

    constructor(private $element: ng.IDocumentService) {}

    $onInit(): void {
        this.elem = this.$element[0];
    }

    $doCheck(): void {
        if (!this.doCheckListenerRegistered) {
            return;
        }

        if (!this.ngModelCtrl) {
            return;
        }
        if (
            this.ngModelCtrl.$invalid &&
            (this.ngFormCtrl.$submitted || this.anyParentFormSubmitted())
        ) {
            this.toggleClass(true);
            return;
        }

        // Type-safety can not be leveraged here.
        this.toggleClass(
            this.ngModelCtrl.$invalid &&
                (this.pkpHasErrorAttr.length
                    ? this.ngModelCtrl[`$${this.pkpHasErrorAttr}`]
                    : true)
        );
    }

    public registerDoCheckListener(
        ngFormCtrl: angular.IFormController,
        ngModelCtrl: angular.INgModelController,
        pkpHasErrorAttr: string
    ) {
        this.ngFormCtrl = ngFormCtrl;
        this.ngModelCtrl = ngModelCtrl;
        this.pkpHasErrorAttr = pkpHasErrorAttr;
        this.doCheckListenerRegistered = true;
    }

    private toggleClass(toggle: boolean): void {
        toggle
            ? this.elem.classList.add('has-error')
            : this.elem.classList.remove('has-error');
    }

    /**
     * The submitted state does not propagate, so it's checked for by ourselves.
     * @see https://github.com/angular/angular.js/issues/10071
     */
    private anyParentFormSubmitted(): boolean {
        let form: ng.IFormController = this.ngFormCtrl;

        while (!!form.$$parentForm) {
            if (form.$submitted) {
                return true;
            }
            form = form.$$parentForm;
        }

        // noinspection PointlessBooleanExpressionJS
        return !!form.$submitted;
    }
}

class HasErrorElem implements ng.IDirective {
    public restrict = 'A';
    public scope = false;
    public controller = HasErrorElemCtrl;

    public link: ng.IDirectiveLinkFn = (
        scope: ng.IScope,
        elem: JQuery,
        attrs: ng.IAttributes
    ) => {};
}

HasErrorElemCtrl.$inject = ['$element'];

angular.module('app').directive('pkpHasErrorElem', () => new HasErrorElem());
